import { Component, AfterViewInit, ViewChild, ElementRef } from '@angular/core';
import { GridOptions } from 'ag-grid';
import { Router } from '@angular/router';

import * as encoding from 'encoding-japanese';

import { ShipApplyLogService } from '../../../service/ship-apply-log/ship-apply-log.service';
import { CommonService } from '../../../service/common/common.service';
import { DialogsService } from '../../../../component/dialog/dialogs.service';
import { HeaderComponent } from '../../../../app/menu/header/header.component';
import { environment } from '../../../../environments/environment';
import { config } from '../../../util/config';
import { insertcomma } from '../../../util/util';
import { AgGridHelper } from '../../../util/AgGridHelper';

@Component({
  selector: 'app-root',
  templateUrl: 'wa3017.component.html',
  styleUrls: ['wa3017.component.scss']
})
export class Wa3017Component implements AfterViewInit {
  private gridApi: any;
  public componentTitle = 'WA3017:出荷引当ログ照会';
  public updprogramCd = 'WA3017';

  @ViewChild(HeaderComponent)
  private headerComponent: HeaderComponent;

  private isEnableClearFilterButton = false;
  private gridHelper: AgGridHelper;

  public gridOptions: GridOptions;
  public showGrid: boolean;
  public rowData: any[];

  public ownerId: number;
  public ownerResult: any;

  public config = config;

  public working = false;
  public containerHeight = 500;
  public cardHeight = 500;
  public gridHeight = 500;
  public production = environment.production;
  public backgroundColor: string;
  private errorInfo = '';

  @ViewChild('gridView')
  gridView: ElementRef;

  private paginationGetRowCount = 0;
  private paginationGetTotalPages = 0;
  private paginationGetCurrentPage = 0;
  private paginationGoToFirstPage;
  private paginationGoToNextPage;
  public rowsPerPageModel = [{ value: 10, viewValue: '10' }, { value: 20, viewValue: '20' }, { value: 100, viewValue: '100' }, { value: 500, viewValue: '500' }];
  public rowsPerPage = config.rowsPerPageSize;

  private isOwnerSearchNone = false;

  constructor(private router: Router, private shipApplyLogService: ShipApplyLogService, private commonService: CommonService, private dialogsService: DialogsService) {
    this.gridHelper = new AgGridHelper();
    this.gridOptions = <GridOptions>{
      pagination: true,
      floatingFilter: true,
      enableRangeSelection: true,
      localeText: environment.gridLocale,
      getContextMenuItems: this.getContextMenuItems,
      onColumnResized: this.saveColumnWidth,
      paginationPageSize: this.rowsPerPage,
      onColumnMoved: () => {
        this.saveColumnOrder();
      },
      onGridReady: params => {
        this.gridApi = params;
        const columns = [];
        for (const column of params.columnApi.getAllDisplayedColumns()) {
          const idx = localStorage.getItem(`wa3017_${column.getColId()}_idx`);
          if (idx !== null) {
            columns.push({ idx: parseInt(idx, 10), column: column });
          }
        }
        columns.sort((a, b) => {
          return a.idx - b.idx;
        });
        for (let i = columns.length - 1; i >= 0; i--) {
          const column = columns[i];
          params.columnApi.moveColumn(column.column, column.idx);
        }
      },
      overlayLoadingTemplate: this.gridHelper.TEMPLATE_GRID_LOADING,
      overlayNoRowsTemplate: this.gridHelper.TEMPLATE_GRID_NODATA,
      onFilterChanged: () => {
        this.isEnableClearFilterButton = this.gridOptions.api.isAnyFilterPresent();
        this.gridHelper.onGridFilterChanged();
        this.errorInfo = '';
      },
      onPaginationChanged: () => {
        this.paginationGetRowCount = this.gridOptions.api.paginationGetRowCount();
        this.paginationGetTotalPages = this.gridOptions.api.paginationGetTotalPages();
        this.paginationGetCurrentPage = this.gridOptions.api.paginationGetCurrentPage() + 1;
        this.gridHelper.renderScrollArrow();
        this.gridHelper.renderGridCheckboxImage();
      },
      onRowDataChanged: () => {
        this.errorInfo = '';
        this.gridHelper.onRowDataChanged();
      },
      postProcessPopup: params => {
        this.errorInfo = '';
        this.gridHelper.fixedAgMenu();
      }
    };

    this.gridOptions.columnDefs = [
      {
        headerName: '受付日時',
        headerTooltip: '受付日時',
        field: 'queueingDt',
        width: this.getColumnWidth('queueingDt', 160),
        sort: 'desc',
        comparator: this.queueingDtComparator,
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '開始日時',
        headerTooltip: '開始日時',
        field: 'startDt',
        width: this.getColumnWidth('startDt', 160),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '終了日時',
        headerTooltip: '終了日時',
        field: 'endDt',
        width: this.getColumnWidth('endDt', 160),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '処理結果',
        headerTooltip: '処理結果',
        field: 'resultTx',
        width: this.getColumnWidth('resultTx', 250),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '荷主コード',
        field: 'ownerCd',
        width: this.getColumnWidth('ownerCd', 100),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '荷主名',
        field: 'ownerTx',
        width: this.getColumnWidth('ownerTx', 140),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '引当実行者名',
        headerTooltip: '引当実行者名',
        field: 'queueinguserTx',
        width: this.getColumnWidth('queueinguserTx', 140),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: 'オーダ数',
        field: 'orderNr',
        width: this.getColumnWidth('orderNr', 80),
        valueFormatter: insertcomma,
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tr', 'cellclass']
      },
      {
        headerName: '明細数',
        field: 'detNr',
        width: this.getColumnWidth('detNr', 80),
        valueFormatter: insertcomma,
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tr', 'cellclass']
      }
    ];
    this.ownerResult = sessionStorage.getItem('ownerResult');
    if (this.ownerResult !== null) {
      const selectedOwner = JSON.parse(this.ownerResult);
      this.ownerId = selectedOwner.ownerId;
    }
    this.containerHeight = window.innerHeight - config.containerheaderMargin;
    this.cardHeight = window.innerHeight - config.headerMargin;
    this.gridHeight = window.innerHeight - config.headerMargin - config.containerButtonMargin;
    if (this.production) {
      this.backgroundColor = 'primary';
    } else {
      this.backgroundColor = 'warn';
    }
    this.gridHelper.setGridOptions(this.gridOptions);
  }

  getColumnWidth(id: string, def: number): number {
    return parseInt(localStorage.getItem(`wa3017_${id}_width`), 10) || def;
  }

  // 受付日時の並び替え
  // キュー方式導入前のログは受付日時を持たないため、昇順・降順のいずれでも末尾に寄せる。
  // 降順時はag-Grid側で戻り値が反転されるため、isInvertedを見て符号を打ち消す。
  queueingDtComparator(valueA, valueB, nodeA?, nodeB?, isInverted?): number {
    const emptyA = valueA === null || valueA === undefined || valueA === '';
    const emptyB = valueB === null || valueB === undefined || valueB === '';
    if (emptyA && emptyB) {
      return 0;
    }
    if (emptyA || emptyB) {
      const toTail = emptyA ? 1 : -1;
      return isInverted ? -toTail : toTail;
    }
    if (valueA === valueB) {
      return 0;
    }
    return valueA < valueB ? -1 : 1;
  }

  saveColumnWidth(params) {
    if (params.finished === true && params.type === 'columnResized') {
      localStorage.setItem(`wa3017_${params.column.colId}_width`, params.column.actualWidth);
    }
  }

  saveColumnOrder() {
    let idx = 0;
    for (const column of this.gridApi.columnApi.getAllDisplayedColumns()) {
      if (column.colId !== '0') {
        localStorage.setItem(`wa3017_${column.colId}_idx`, `${idx}`);
      }
      idx++;
    }
  }

  getContextMenuItems(params) {
    const str_to_unicode_array = str => {
      const arr = [];
      for (let i = 0; i < str.length; i++) {
        arr.push(str.charCodeAt(i));
      }
      return arr;
    };

    const download = csvString => {
      // Unicode コードポイントの配列に変換する
      const unicode_array = str_to_unicode_array(csvString);
      // S-JIS コードポイントの配列に変換
      const sjis_code_array = encoding.convert(
        unicode_array, // ※文字列を直接渡すのではない点に注意
        'SJIS', // to
        'UNICODE' // from
      );
      // 文字コード配列をTypedArrayに変換する
      const uint8_array = new Uint8Array(sjis_code_array);
      // 指定されたデータを保持するBlobを作成する
      const blob = new Blob([uint8_array], { type: 'text/csv' });
      // Internet Explorer
      if (window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(blob, 'export.csv');
      } else {
        // Chrome
        const downloadLink = document.createElement('a');
        downloadLink.href = window.URL.createObjectURL(blob);
        downloadLink.download = 'export.csv';
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
      }
    };

    const result = [
      'copy',
      'copyWithHeaders',
      'separator',
      {
        name: 'エクスポート',
        subMenu: [
          {
            name: 'チェックした行をCSVエクスポート',
            action: () => {
              download(params.api.getDataAsCsv({ onlySelected: true }));
            }
          },
          {
            name: 'すべてCSVエクスポート',
            action: () => {
              download(params.api.getDataAsCsv());
            }
          },
          'excelExport'
        ]
      }
    ];

    return result;
  }

  onResize(event) {
    this.containerHeight = window.innerHeight - config.containerheaderMargin;
    this.cardHeight = window.innerHeight - config.headerMargin;
  }

  //表示件数の変更
  paginatorRowChange() {
    this.gridOptions.api.paginationSetPageSize(this.rowsPerPage);
    localStorage.setItem('wa6020_rowsPerPage_idx', `${this.rowsPerPage}`);
  }

  onResizeGrid(event) {
    this.gridHeight = event.target.innerHeight - config.headerMargin - config.containerButtonMargin;
  }

  changeOwner(selectedOwnerId) {
    if (selectedOwnerId !== null) {
      if (selectedOwnerId !== undefined) {
        this.ownerId = selectedOwnerId;
      } else {
        this.ownerId = undefined;
      }
      this.onSubmit();
    } else {
      this.rowData = [];
      this.gridOptions.api.deselectAll();
    }
  }

  ngAfterViewInit() {
    this.gridHelper.el = this.gridView;

    setTimeout(() => {
      this.onSubmit();
    }, config.waitMsForSearchInNgAfterViewInit);
  }

  onFilterClearAndSubmit() {
    this.gridOptions.api.setFilterModel(null);
  }

  onSubmit() {
    //SW-2103　ダブルクリック抑止
    if (this.working) return;
    this.working = true;
    this.gridOptions.api.showLoadingOverlay();
    const params: URLSearchParams = new URLSearchParams();
    if (this.ownerId !== undefined) {
      params.set('ownerId', this.ownerId.toString());
    }
    this.shipApplyLogService
      .get(params)
      .then(outputJson => {
        this.rowData = outputJson.shipapplylogs;
        setTimeout(() => {
          this.gridOptions.api.hideOverlay();
          this.working = false;
        },300);
      })
      .catch(error => {
        this.working = false;
        this.gridOptions.api.hideOverlay();
        this.errorInfo = this.commonService.getErrorMessage(error);
      });
  }

  gotoShip() {
    this.router.navigate(['wa3010']);
  }

  ownerInputChanged(ownerId: string) {
    this.gridHelper.isOwnerNotFound = ownerId == null && ownerId !== undefined;
    this.changeOwner(ownerId);
  }
}



// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/pages/wa3Shipment/wa3017/wa3017.component.ts